import { createI18n } from 'vue-i18n'

const ru = {
  brand: { name: 'Fitness', caption: 'управление клубом' },
  nav: {
    overview: 'Обзор', clients: 'Клиенты', memberships: 'Абонементы',
    schedule: 'Расписание', attendance: 'Посещения', settings: 'Настройки', logout: 'Выйти',
  },
  auth: {
    eyebrow: 'Рабочее пространство клуба', title: 'Всё важное — в одном ритме.',
    subtitle: 'Продажи, расписание, посещения и команда — без таблиц и ручной сверки.',
    club: 'Код организации', email: 'Электронная почта', password: 'Пароль',
    signIn: 'Войти в систему',
  },
  common: {
    add: 'Добавить', save: 'Сохранить', cancel: 'Отмена', search: 'Поиск',
    loading: 'Загрузка…', error: 'Не удалось выполнить действие', noData: 'Пока нет данных',
    currency: '₸', today: 'Сегодня', status: 'Статус', all: 'Все', refresh: 'Обновить',
  },
  overview: {
    eyebrow: 'Пульс клуба', title: 'Доброе утро, {name}', subtitle: 'Клуб работает стабильно. Вот ключевые показатели на сегодня.',
    clients: 'Клиентов', memberships: 'Активных абонементов', sessions: 'Занятий сегодня',
    revenue: 'Выручка за месяц', upcoming: 'Ближайшие занятия', load: 'Заполнено {booked} из {capacity}',
    quickTitle: 'Быстрые действия', addClient: 'Новый клиент', createSession: 'Добавить занятие', checkIn: 'Отметить посещение',
  },
  clients: {
    eyebrow: 'CRM', title: 'Клиенты', subtitle: 'Вся история отношений с клубом в одной карточке.',
    add: 'Новый клиент', firstName: 'Имя', lastName: 'Фамилия', phone: 'Телефон',
    email: 'Email', source: 'Источник', tags: 'Теги', created: 'Добавлен', fullName: 'Клиент',
  },
  memberships: {
    eyebrow: 'Каталог и продажи', title: 'Абонементы', subtitle: 'Прозрачные условия, остатки и история движений.',
    addPlan: 'Новый тариф', sell: 'Продать абонемент', name: 'Название', price: 'Цена, ₸',
    duration: 'Срок, дней', visits: 'Посещений', unlimited: 'Безлимит', activation: 'Активация',
    client: 'Клиент', plan: 'Тариф', paid: 'Оплачено, ₸', method: 'Способ оплаты',
  },
  schedule: {
    eyebrow: 'Расписание', title: 'Занятия', subtitle: 'Группы, залы и загрузка — без конфликтов.',
    add: 'Новое занятие', name: 'Название', branch: 'Филиал', room: 'Зал', start: 'Начало',
    end: 'Окончание', capacity: 'Вместимость', booked: 'Записано',
  },
  attendance: {
    eyebrow: 'Контроль доступа', title: 'Посещения', subtitle: 'Быстрый check-in с атомарным списанием визита.',
    choose: 'Выберите клиента', checkIn: 'Выполнить check-in', success: 'Доступ разрешён',
    denied: 'Доступ отклонён', remaining: 'Осталось посещений: {count}',
  },
  settings: {
    eyebrow: 'Интеграции', title: 'Настройки клуба', subtitle: 'Подключайте сервисы без хранения секретов в браузере.',
    kaspi: 'Kaspi Pay', kaspiText: 'Привяжите БИН организации и получите ID счёта через защищённый серверный адаптер.',
    bin: 'БИН (12 цифр)', organization: 'Название организации', connect: 'Получить ID счёта',
    connected: 'ID счёта: {id}', unavailable: 'На сервере ещё не настроен ключ провайдера Kaspi.',
  },
}

const kz = {
  ...ru,
  brand: { name: 'Fitness', caption: 'клубты басқару' },
  nav: { ...ru.nav, overview: 'Шолу', clients: 'Клиенттер', memberships: 'Абонементтер', schedule: 'Кесте', attendance: 'Келулер', settings: 'Баптаулар', logout: 'Шығу' },
  common: { ...ru.common, add: 'Қосу', save: 'Сақтау', cancel: 'Бас тарту', search: 'Іздеу', loading: 'Жүктелуде…', noData: 'Деректер жоқ' },
}

export default createI18n({ legacy: false, locale: 'ru', fallbackLocale: 'ru', messages: { ru, kz } })
